import React, { Component } from 'react';
import { debounce } from 'lodash';
import Helmet from 'react-helmet';
import b from 'b_';

import Events from 'client/components/events';
import Filters from 'client/components/filters';
import { FilterQueryParams, getFilters, getFiltersFromQuery } from 'client/components/filters/filters-query';
import { Homepage } from 'client/types/homepage';
import { List } from 'client/types/common';
import { Event } from 'client/types/event';
import { ApiFilters } from 'client/types/filters';
import pageMeta from './home.meta';

const class_ = b.with('page');

export interface DispatchProps {
    fetchHomepage(): any;
    fetchEvents(params?: { filters: ApiFilters, pageNumber?: number }): any;
}

export interface StateProps {
    data: Homepage;
    isLoading: boolean;
    isEventsLoading: boolean;
    events: List<Event>;
}

type Props = StateProps & DispatchProps & {
    q: string;
    onChangeUrlQueryParams: (params: object) => void;
};

interface State {
    initiated: boolean;
    pageNumber: number;
    filters?: ApiFilters
}

export default class HomePage extends Component<Props, State> {
    static getDerivedStateFromProps(nextProps: Props, prevState: State) {
        const { filters } = getFiltersFromQuery(nextProps.q);

        if (prevState.initiated) {
            return null;
        }

        return {
            filters,
            pageNumber: 1,
            initiated: true
        };
    }

    state: State = {
        initiated: false,
        pageNumber: 1
    };

    componentDidMount() {
        const { fetchHomepage, fetchEvents, data: { filters }, q } = this.props;

        if (!Object.keys(filters).length) {
            fetchHomepage();
            fetchEvents({ filters: getFiltersFromQuery(q) });
        }
    }

    render() {
        const {
            isLoading,
            isEventsLoading,
            data: { filters },
            events,
            q
        } = this.props;

        const filtersProps = getFiltersFromQuery(q);

        return (
            <div className={class_({ type: 'home' })}>
                <Helmet>
                    <title>{pageMeta.title}</title>
                    <meta name="description" content={pageMeta.description} />
                    <meta name="keywords" content={pageMeta.keywords} />
                </Helmet>
                <h1>Мероприятия Яндекса</h1>
                <Filters
                    data={filters}
                    isLoading={isLoading}
                    onChangeFilters={debounce(this.onChangeFilters, 200)}
                    {...filtersProps}
                />
                <Events
                    data={events}
                    isLoading={isEventsLoading}
                    onClickToShowMore={this.onClickToShowMore}
                />
            </div>
        );
    }

    onLoadEvents = () => {
        const { fetchEvents } = this.props;
        const { pageNumber, filters = {} } = this.state;

        fetchEvents({ filters, pageNumber });
    };

    onClickToShowMore = () => {
        this.setState({ pageNumber: this.state.pageNumber + 1 }, this.onLoadEvents);
    };

    onChangeFilters = (params: FilterQueryParams) => {
        const filters = getFilters(params);

        this.props.onChangeUrlQueryParams({ q: JSON.stringify(params) });

        this.setState({ filters, pageNumber: 1 }, () => {
            this.onLoadEvents();
        });
    };
}
